import React from 'react';
import s from './NoAccess.module.scss';

export const NoAccess = (): JSX.Element => {
  return (
    <div className={s.image}>
      <div className={s.image__notfoundtext}>
        <p className={s.image__announce}>
          Ahh, þú hefur ekki réttindi til að skoða þessa síðu.
        </p>
        <p className={s.image__sub}>
          <a href="https://midjan.landsvirkjun.is" rel="noreferrer">
            Viltu fara á Miðjuna?
          </a>
        </p>
      </div>
    </div>
  );
};
